import {combineReducers} from "redux";
import licenseReducer from "./licenseReducer";
import auditReducer from "./auditReducer";
import signExtensionReducer from "./signExtensionReducer";

export default combineReducers({
    license: licenseReducer,
    signExtension: signExtensionReducer,
    audit: auditReducer
});